import React from 'react';
import './cover.css';

export default function Cover() {
  return (
    <header id="Cover">
        <div className="cover--container">
            <div className='cover--section--one'>
                <h1 className='animate__animated animate__fadeInLeft'>Hey, I'm Dave</h1>
                <h4 className='animate__animated animate__fadeInRight'>
                    a front-end developer focused on writing clean and efficient code.<br/>
                    I'm passionate about minimalism, responsive design and the research<br/>
                    for the most intuitive and effective UX design.
                </h4>
            </div>
            <div className='cover--section--two animate__animated animate__fadeInUp'>
                <a href="#Contact" className='button' id='coverButton'>
                    <i className="bi bi-code link--icons"></i>
                    Get in touch or...
                </a>
                <p>Learn more about me and what I do</p>
                <i className="bi bi-chevron-double-down animate__animated animate__pulse"></i>
            </div>
        </div>
    </header>
  )
}
